import { api } from 'base/utils/api';
import { ICheckInData } from 'mod/checkIn/interface';

export const getCheckInConfig = (): Promise<ICheckInData> => {
    return api.get('/web/checkin/config', {
        params: {
            type: 'SHARE_BOOM'
        }
    })
};

export async function postCheckIn(activityGid: string): Promise<{ checkIn: boolean; }> {
    return api.post('/web/checkin/sign', {
        data: { activityGid }
    })
}

export async function postShare(activityGid: string): Promise<{ checkIn: boolean; }> {
    return api.post('/web/checkin/share', {
        data: { activityGid }
    })
}

export const flushCache = (activityGid: string): Promise<void> => {
    return api.get('/web/checkin/flush-cache', {
        params: {
            activityGid
        }
    })
};